import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import CircularLoader from "../../Component/CircularLoader";

import kiranImg from "../../assets/images/kiran-foundation-logo.png";
import payproLogo from "../../assets/images/paypro-logo-50px.png";

// How To Pay Images
import urduPaymentImage from "../../assets/images/Horizontal-both-URD-scaled.jpg";
import englishPaymentImage from "../../assets/images/Horizontal-Both-eng-scaled.jpg";

const KiranFoundation = () => {
    // ==========================================
    // Form State
    // ==========================================
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        address: "",
        amount: "",
        paymentType: "Zakat",
    });

    // ==========================================
    // Errors
    // ==========================================
    const [errors, setErrors] = useState({});

    // ==========================================
    // Loading
    // ==========================================
    const [loading, setLoading] = useState(false);

    // ==========================================
    // Payment Modal
    // null = closed
    // urdu = Urdu image
    // english = English image
    // ==========================================
    const [paymentModal, setPaymentModal] = useState(null);

    // ==========================================
    // Prevent Body Scroll When Modal Is Open
    // ==========================================
    useEffect(() => {
        if (paymentModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [paymentModal]);

    // ==========================================
    // Get PayPro Credentials
    // ==========================================
    const getCredentials = () => {
        if (formData.paymentType === "Zakat") {
            return {
                username: 'Kiran_Zakat',
                password: 'Live@zakat21',
                clientId: "pUasj7AwTObESco",
                clientSecret:'rssw2As6jGLV6kb',
            };
        }

        return {
            username: "Kiran_Flagship",
            password: 'Live@flagship21',
            clientId: 'psYoTHY5wYOb8gT',
            clientSecret:'yeMAstBWVDfJ5o8',
        };
    };

    // ==========================================
    // Handle Input Change
    // ==========================================
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    // ==========================================
    // Validate Form
    // ==========================================
    const validateForm = () => {
        const newErrors = {};

        // Name
        if (!formData.name.trim()) {
            newErrors.name = "Name is required.";
        }

        // Email
        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
            newErrors.email = "Email address is invalid.";
        }

        // Phone
        if (!formData.phoneNumber.trim()) {
            newErrors.phoneNumber = "Phone number is required.";
        } else if (!/^03\d{9}$/.test(formData.phoneNumber.trim())) {
            newErrors.phoneNumber =
                "Please enter a valid phone number (03XXXXXXXXX).";
        }

        // Amount
        if (!formData.amount) {
            newErrors.amount = "Amount is required.";
        } else if (Number(formData.amount) <= 0) {
            newErrors.amount = "Amount must be greater than 0.";
        } else if (Number(formData.amount) > 300000) {
            newErrors.amount =
                "The amount should not exceed PKR 300,000 per transaction.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ==========================================
    // Get PayPro Auth Token
    // ==========================================
    const getAuthToken = async (clientId, clientSecret) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`,
                {
                    clientid: clientId,
                    clientsecret: clientSecret,
                }
            );

            return response?.data?.token;
        } catch (error) {
            console.error("PayPro Auth Error:", error);

            throw new Error(
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "Unable to authenticate with PayPro."
            );
        }
    };

    // ==========================================
    // Create PayPro Order
    // ==========================================
    const payproCreateOrder = async (e) => {
        e.preventDefault();

        // Prevent duplicate submission
        if (loading) {
            return;
        }

        // Validate form
        const isValid = validateForm();

        if (!isValid) {
            return;
        }

        try {
            setLoading(true);

            // ==========================================
            // Current Date
            // ==========================================
            const currentDate = new Date();

            // ==========================================
            // Due Date = Current Date + 3 Days
            // ==========================================
            const dueDate = new Date(currentDate);
            dueDate.setDate(dueDate.getDate() + 3);

            // ==========================================
            // Format PayPro Date
            // ==========================================
            const formatPayProDate = (date) => {
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();

                return `${day}-${month}-${year}`;
            };

            // ==========================================
            // Get Credentials
            // ==========================================
            const credentials = getCredentials();

            if (
                !credentials.clientId ||
                !credentials.clientSecret ||
                !credentials.username
            ) {
                throw new Error(
                    "PayPro credentials are not configured properly."
                );
            }

            // ==========================================
            // Get PayPro Token
            // ==========================================
            const token = await getAuthToken(
                credentials.clientId,
                credentials.clientSecret
            );

            if (!token) {
                throw new Error(
                    "PayPro authentication token was not received."
                );
            }

            // ==========================================
            // Order Number
            // ==========================================
            const orderNumber = `${Date.now()}`;

            // ==========================================
            // PayPro Payload
            // ==========================================
            const payload = [
                {
                    MerchantId: credentials.username,
                },
                {
                    OrderNumber: orderNumber,

                    OrderAmount: String(formData.amount),

                    OrderDueDate: formatPayProDate(dueDate),

                    OrderType: "Service",

                    IssueDate: formatPayProDate(currentDate),

                    OrderExpireAfterSeconds: "0",

                    CustomerName: formData.name.trim(),

                    CustomerMobile: formData.phoneNumber.trim(),

                    CustomerEmail: formData.email.trim(),

                    CustomerAddress: formData.address.trim(),


                },
            ];

            console.log("PayPro Payload:", payload);

            // ==========================================
            // PayPro Headers
            // ==========================================
            const headers = {
                token: token,
                "Content-Type": "application/json",
            };

            // ==========================================
            // PayPro Create Order URL
            // ==========================================
            const url =
                `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;

            // ==========================================
            // Create Order
            // ==========================================
            const response = await axios.post(url, payload, {
                headers,
            });

            console.log("PayPro Response:", response?.data);

            // ==========================================
            // Extract PayPro Response
            // ==========================================
            const payProData = response?.data?.data;

            // ==========================================
            // Invalid Response
            // ==========================================
            if (!Array.isArray(payProData) || payProData.length < 2) {
                throw new Error(
                    "Invalid response received from PayPro. Please try again."
                );
            }

            // ==========================================
            // Response Status
            // ==========================================
            const status = payProData?.[0]?.Status;

            const description =
                payProData?.[1]?.Description ||
                payProData?.[0]?.Description ||
                "";

            // ==========================================
            // PayPro Error Response
            // ==========================================
            if (status === "03") {
                setLoading(false);

                await Swal.fire({
                    icon: "error",
                    title: "Payment Failed",
                    text:
                        description ||
                        "Unable to create your payment order. Please try again.",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#171827",
                });

                return;
            }

            // ==========================================
            // Get Payment URL
            // ==========================================
            const marketplaceUrl = payProData?.[1]?.Click2Pay;

            // ==========================================
            // Payment URL Missing
            // ==========================================
            if (!marketplaceUrl) {
                throw new Error(
                    description ||
                    "Payment URL was not received from PayPro. Please try again."
                );
            }

            // ==========================================
            // Success
            // ==========================================
            setLoading(false);

            await Swal.fire({
                icon: "success",
                title: "Payment Order Created",
                text: "Redirecting you to the payment page...",
                showConfirmButton: false,
                timer: 1500,
            });

            // ==========================================
            // Redirect
            // ==========================================
            window.location.replace(marketplaceUrl);
        } catch (error) {
            console.error("Error creating PayPro order:", error);

            setLoading(false);

            await Swal.fire({
                icon: "error",
                title: "Payment Error",
                text:
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error?.message ||
                    "Something went wrong while creating the payment.",
                confirmButtonText: "OK",
                confirmButtonColor: "#171827",
            });
        }
    };

    // ==========================================
    // Close Payment Modal
    // ==========================================
    const closePaymentModal = () => {
        setPaymentModal(null);
    };

    // ==========================================
    // Handle Escape Key
    // ==========================================
    const handleModalKeyDown = (e) => {
        if (e.key === "Escape") {
            closePaymentModal();
        }
    };

    return (
        <>
            {/* =====================================================
                MAIN CONTAINER
            ====================================================== */}
            <div className="min-h-screen bg-white px-4 py-5 sm:px-6 sm:py-7 md:px-8 lg:px-10">
                <div className="mx-auto w-full max-w-[1010px]">
                    {/* =====================================================
                        KIRAN FOUNDATION LOGO
                    ====================================================== */}
                    <div className="mb-6 flex justify-center sm:justify-start">
                        <img
                            src={kiranImg}
                            alt="Kiran Foundation"
                            className="
                                h-auto
                                w-[100px]
                                object-contain

                            "
                        />
                    </div>

                    {/* =====================================================
                        FORM
                    ====================================================== */}
                    <form
                        onSubmit={payproCreateOrder}
                        className="w-full"
                    >
                        {/* =====================================================
                            NAME + EMAIL
                        ====================================================== */}
                        <div className="grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-2 md:gap-x-10">
                            {/* Name */}
                            <div className="w-full">
                                <label className="mb-2 block text-[14px] font-medium text-[#687083] sm:text-[15px] md:text-[16px]">
                                    Name
                                    <span className="text-red-600"> *</span>
                                </label>

                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Full Name"
                                    autoComplete="name"
                                    className={`w-full border-0 border-b bg-transparent px-0 pb-3 text-[15px] text-gray-700 outline-none placeholder:text-[#aaa] focus:ring-0 sm:text-[16px] ${
                                        errors.name
                                            ? "border-red-500"
                                            : "border-[#d6d6d6] focus:border-gray-500"
                                    }`}
                                />

                                {errors.name && (
                                    <p className="mt-1 text-xs text-red-600 sm:text-sm">
                                        {errors.name}
                                    </p>
                                )}
                            </div>

                            {/* Email */}
                            <div className="w-full">
                                <label className="mb-2 block text-[14px] font-medium text-[#687083] sm:text-[15px] md:text-[16px]">
                                    Email
                                    <span className="text-red-600"> *</span>
                                </label>

                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Your Email Address"
                                    autoComplete="email"
                                    className={`w-full border-0 border-b bg-transparent px-0 pb-3 text-[15px] text-gray-700 outline-none placeholder:text-[#aaa] focus:ring-0 sm:text-[16px] ${
                                        errors.email
                                            ? "border-red-500"
                                            : "border-[#d6d6d6] focus:border-gray-500"
                                    }`}
                                />

                                {errors.email && (
                                    <p className="mt-1 text-xs text-red-600 sm:text-sm">
                                        {errors.email}
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* =====================================================
                            PHONE + ADDRESS
                        ====================================================== */}
                        <div className="mt-5 grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-2 md:gap-x-10">
                            {/* Phone */}
                            <div className="w-full">
                                <label className="mb-2 block text-[14px] font-medium text-[#687083] sm:text-[15px] md:text-[16px]">
                                    Phone Number
                                    <span className="text-red-600"> *</span>
                                </label>

                                <input
                                    type="tel"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    placeholder="03XXXXXXXXX"
                                    maxLength={11}
                                    inputMode="numeric"
                                    autoComplete="tel"
                                    className={`w-full border-0 border-b bg-transparent px-0 pb-3 text-[15px] text-gray-700 outline-none placeholder:text-[#aaa] focus:ring-0 sm:text-[16px] ${
                                        errors.phoneNumber
                                            ? "border-red-500"
                                            : "border-[#d6d6d6] focus:border-gray-500"
                                    }`}
                                />

                                {errors.phoneNumber && (
                                    <p className="mt-1 text-xs text-red-600 sm:text-sm">
                                        {errors.phoneNumber}
                                    </p>
                                )}
                            </div>

                            {/* Address */}
                            <div className="w-full">
                                <label className="mb-2 block text-[14px] font-medium text-[#687083] sm:text-[15px] md:text-[16px]">
                                    Address
                                </label>

                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="Enter your current address"
                                    autoComplete="street-address"
                                    className="w-full border-0 border-b border-[#d6d6d6] bg-transparent px-0 pb-3 text-[15px] text-gray-700 outline-none placeholder:text-[#aaa] focus:border-gray-500 focus:ring-0 sm:text-[16px]"
                                />
                            </div>
                        </div>

                        {/* =====================================================
                            AMOUNT
                        ====================================================== */}
                        <div className="mt-5 w-full">
                            <label className="mb-2 block text-[14px] font-medium text-[#687083] sm:text-[15px] md:text-[16px]">
                                Amount
                                <span className="text-red-600"> *</span>
                            </label>

                            <input
                                type="number"
                                name="amount"
                                value={formData.amount}
                                onChange={handleChange}
                                min="1"
                                max="300000"
                                inputMode="numeric"
                                placeholder="Enter amount"
                                className={`w-full border-0 border-b bg-transparent px-0 pb-3 text-[15px] text-gray-700 outline-none placeholder:text-[#aaa] focus:ring-0 sm:text-[16px] ${
                                    errors.amount
                                        ? "border-red-500"
                                        : "border-[#d6d6d6] focus:border-gray-500"
                                }`}
                            />

                            {errors.amount && (
                                <p className="mt-1 text-xs text-red-600 sm:text-sm">
                                    {errors.amount}
                                </p>
                            )}
                        </div>

                        {/* =====================================================
                            PAYMENT TYPE
                        ====================================================== */}
                        <div className="mt-5">
                            <label className="mb-3 block text-[14px] font-medium text-[#687083] sm:text-[15px] md:text-[16px]">
                                Payment Type :
                                <span className="text-red-600"> *</span>
                            </label>

                            <div className="flex flex-col gap-2 sm:flex-row sm:gap-6">
                                {/* Zakat */}
                                <label className="flex cursor-pointer items-center gap-2 text-[15px] text-[#687083] sm:text-[16px]">
                                    <input
                                        type="radio"
                                        name="paymentType"
                                        value="Zakat"
                                        checked={
                                            formData.paymentType === "Zakat"
                                        }
                                        onChange={handleChange}
                                        className="h-4 w-4 cursor-pointer accent-[#171827]"
                                    />

                                    <span>Zakat</span>
                                </label>

                                {/* Donation */}
                                <label className="flex cursor-pointer items-center gap-2 text-[15px] text-[#687083] sm:text-[16px]">
                                    <input
                                        type="radio"
                                        name="paymentType"
                                        value="Donation"
                                        checked={
                                            formData.paymentType === "Donation"
                                        }
                                        onChange={handleChange}
                                        className="h-4 w-4 cursor-pointer accent-[#171827]"
                                    />

                                    <span>Donation</span>
                                </label>
                            </div>
                        </div>

                        {/* =====================================================
                            SUBMIT
                        ====================================================== */}
                        <div className="mt-6">
                            <button
                                type="submit"
                                disabled={loading}
                                className="
                                    flex
                                    min-h-[44px]
                                    w-full
                                    items-center
                                    justify-center
                                    gap-2
                                    rounded-md
                                    bg-[#171827]
                                    px-4
                                    py-2.5
                                    text-[15px]
                                    font-medium
                                    text-white
                                    transition
                                    hover:bg-[#242536]
                                    active:scale-[0.99]
                                    disabled:cursor-not-allowed
                                    disabled:opacity-70
                                    sm:text-[16px]
                                "
                            >
                                {loading ? (
                                    <>
                                        <span>Processing...</span>

                                        <CircularLoader
                                            spinnerColor="#ffffff"
                                        />
                                    </>
                                ) : (
                                    "Submit"
                                )}
                            </button>
                        </div>
                    </form>

                    {/* =====================================================
                        AMOUNT NOTE
                    ====================================================== */}
                    <div className="mt-6">
                        <p className="text-[13px] leading-5 text-[#111827] sm:text-[15px] md:text-[16px]">
                            <span className="text-red-600">*</span>{" "}
                            The amount should not exceed PKR 300,000 per
                            transaction.
                        </p>
                    </div>

                    {/* =====================================================
                        HOW TO PAY BUTTONS
                    ====================================================== */}
                    <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 md:flex md:items-center md:justify-around md:gap-6">
                        {/* Urdu */}
                        <button
                            type="button"
                            onClick={() => setPaymentModal("urdu")}
                            className="
                                w-full
                                rounded-md
                                bg-[#00b74f]
                                px-5
                                py-3
                                text-[14px]
                                font-semibold
                                text-white
                                transition
                                hover:bg-[#009e44]
                                active:scale-[0.98]
                                sm:text-[15px]
                                md:w-auto
                                md:min-w-[190px]
                                md:text-[16px]
                            "
                        >
                            How To Pay Urdu
                        </button>

                        {/* English */}
                        <button
                            type="button"
                            onClick={() => setPaymentModal("english")}
                            className="
                                w-full
                                rounded-md
                                bg-[#00b74f]
                                px-5
                                py-3
                                text-[14px]
                                font-semibold
                                text-white
                                transition
                                hover:bg-[#009e44]
                                active:scale-[0.98]
                                sm:text-[15px]
                                md:w-auto
                                md:min-w-[190px]
                                md:text-[16px]
                            "
                        >
                            How To Pay English
                        </button>
                    </div>

                    {/* =====================================================
                        PAYPRO LOGO
                    ====================================================== */}
                    <div className="mt-7 flex justify-center sm:justify-end">
                        <img
                            src={payproLogo}
                            alt="PayPro"
                            className="
                                h-auto
                                w-[65px]
                                object-contain

                            "
                        />
                    </div>
                </div>
            </div>

            {/* =========================================================
                HOW TO PAY MODAL
            ========================================================== */}
            {paymentModal && (
                <div
                    className="
                        fixed
                        inset-0
                        z-[99999]
                        flex
                        items-center
                        justify-center
                        bg-black/70
                        p-3
                        sm:p-5
                    "
                    onClick={closePaymentModal}
                    onKeyDown={handleModalKeyDown}
                    role="dialog"
                    aria-modal="true"
                    aria-label={
                        paymentModal === "urdu"
                            ? "How To Pay Urdu"
                            : "How To Pay English"
                    }
                >
                    <div
                        className="
                            relative
                            flex
                            max-h-[95vh]
                            w-full
                            max-w-[900px]
                            flex-col
                            overflow-hidden
                            rounded-lg
                            bg-white
                            shadow-2xl
                            sm:rounded-xl
                        "
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* =================================================
                            MODAL HEADER
                        ================================================== */}
                        <div className="flex shrink-0 items-center justify-between gap-3 border-b border-gray-200 px-4 py-3 sm:px-5 sm:py-4">
                            <h2 className="text-base font-semibold text-gray-800 sm:text-lg">
                                {paymentModal === "urdu"
                                    ? "How To Pay - Urdu"
                                    : "How To Pay - English"}
                            </h2>

                            <button
                                type="button"
                                onClick={closePaymentModal}
                                className="
                                    flex
                                    h-8
                                    w-8
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-full
                                    bg-gray-100
                                    text-xl
                                    leading-none
                                    text-gray-600
                                    transition
                                    hover:bg-gray-200
                                    hover:text-gray-900
                                    sm:h-9
                                    sm:w-9
                                    sm:text-2xl
                                "
                                aria-label="Close modal"
                            >
                                ×
                            </button>
                        </div>

                        {/* =================================================
                            MODAL BODY
                        ================================================== */}
                        <div className="overflow-y-auto bg-white p-2 sm:p-4">
                            <img
                                src={
                                    paymentModal === "urdu"
                                        ? urduPaymentImage
                                        : englishPaymentImage
                                }
                                alt={
                                    paymentModal === "urdu"
                                        ? "How To Pay Urdu"
                                        : "How To Pay English"
                                }
                                className="
                                    mx-auto
                                    h-auto
                                    max-h-[calc(95vh-80px)]
                                    w-full
                                    rounded
                                    object-contain
                                "
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default KiranFoundation;